import React, {Fragment} from 'react';
import Criterion from './Criterion'

const SearchCriteria = props => {
  let {value, onChange } = props

  function criterionOnChange (key, value) {
    onChange(key, value)
  }

  if (!value) {
    return (<p/>)
  }

  return (
      Object.entries(value).map(([key, attributeValue]) => {
        return (
          <Fragment key={key}>
            <Criterion title={attributeValue.title} name={key} value={attributeValue.choices}
              onChange={criterionOnChange}/>
            <p/>
          </Fragment>
        )
      })
  )
}

export default SearchCriteria
